function placeholderStyles(theme) {
  return function () {
    return {
      userSelect: "none",
      color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
    };
  };
}
export { placeholderStyles };